import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { createElement, ReactElement } from "react";
import { ContextCollection } from "../../contexts/DependencyContext";
import { IWidget } from "../http/widget/models/IWidget";
import SummaryFullScreen from "../../pages/DashboardPage/FullscreenDashboardView/SummaryFullScreen";
import NoWidget from "../../components/Shared/ContentBlocks/NoWidget";
import IndicatorList from "../../pages/DashboardPage/FullscreenDashboardView/IndicatorList";
import DateFilters, { IDateRange } from "../../pages/DashboardPage/FullscreenDashboardView/DateFilters";
import StatusHistoryFullScreen from "../../pages/DashboardPage/FullscreenDashboardView/StatusHistoryFullScreen";
import SensorChartFullScreen from "../../pages/DashboardPage/FullscreenDashboardView/SensorChartFullScreen";
import { BaseWidgetService } from "./BaseWidgetService";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class FullScreenWidgetService extends BaseWidgetService
{
    getFullScreenWidgetName(widgetType: string, isDesktop: boolean, widgetName: string): string
    {
        const indicatorListTitle = isDesktop ? "Key Performance Indicators (KPI)" : "KPI";
        return widgetType === this.fullscreenWidgets.indicatorList ? indicatorListTitle : widgetName;
    }

    getWidgetBody(widget: IWidget | undefined, widgetTtype: string, currentFilters: Object | null, widgets: IWidget[]): ReactElement | null
    {
        if (!widget) return null;

        switch (widgetTtype)
        {
            case this.fullscreenWidgets.summary:
                return createElement(SummaryFullScreen, { ...widget });

            case this.fullscreenWidgets.indicatorList:
                return createElement(IndicatorList, { widget, widgets });

            case this.fullscreenWidgets.indicatorStatusHistory:
                return createElement(StatusHistoryFullScreen, { widget: widget, dateFilters: currentFilters as IDateRange[] ?? [] });

            case this.fullscreenWidgets.sensorChart:
                return createElement(SensorChartFullScreen, { widget: widget, dateFilters: currentFilters as IDateRange[] ?? [] });

            default:
                return createElement(NoWidget, widget.widgetType);
        }
    }

    getWidgetFilters = (widget: IWidget | undefined, widgetType: String, fallback: (dateRanges: IDateRange[]) => void): ReactElement | null =>
    {
        if (!widget) return null;

        switch (widgetType)
        {
            case this.fullscreenWidgets.indicatorStatusHistory:
            case this.fullscreenWidgets.sensorChart:
                return createElement(DateFilters, ({ onApply: fallback }));

            default:
                return null;
        }
    }
}